<template>
  <div id="home">
    <!-- 头部banner -->
    <div class="banner">
      <div class="imgs">
          <img src="../../assets/img/home_banner.png" alt="">
      </div>
      <div class="floating pubw">
        <div class="left">
          <div class="h">{{ $t("home.bannerFloting") }}</div>
            <optionsButton class="bannerregisterNow" :title="$t('home.nowSing')" :callback="registerNow" />
        </div>
        <div class="right">
          <span class="el-icon-arrow-right"></span>
        </div>
      </div>
    </div>
    <!-- 选项区 -->
    <section class="options">
      <div class="options_main pubw">
          <div class="tabs">
            <!-- tab头部 -->
            <div class="tabs_header">
              <div :class="curTab==item.value?'tabsHeader_active':''" v-for="item in tabs_header" :key="item.value" @click="handleTabsChange(item.value)">
                <span :class="item.icon"></span>
                <span class="fontH">{{item.title}}</span>
              </div>
            </div>
            <!-- tab主体 -->
            <div class="tabs_content">
              <div class="tips">
                <div class="container">
                  <p class="cast" v-for="(item, index) in broadcast" :key="index" v-html="_i18n.locale == 'en' ? item.contentEn : item.contentCn"></p>
                </div>
              </div>
              <div class="tabItem" v-show="curTab===0">
                <div class="content">
                  <StartingEndPoint/>
                </div>
              <div class="bottom">
                <optionsButton :title="$t('home.tab[0]')" :callback="quoteNow" />
                 <div class="help">{{$t('home.help')}}</div>
              </div>
              </div>
              <div class="tabItem" v-show="curTab===1">
                <div class="content">
                  <div class="top">
                    <div class="left">
                      <div class="h">{{$t("home.queryShipment.company")}}</div>
                      <!-- 选择框 -->
                      <el-select v-model="curSlipment" >
                        <el-option
                          v-for="item in slipmentList"
                          :key="item.id"
                          :label="item.country"
                          :value="item.country">
                          <div>
                            <span style="margin-right: 10px;font-size: 18px;" :class="item.icon"></span>
                            <span>{{item.country}}</span>
                          </div>
                        </el-option>
                      </el-select>
                    </div>
                    <div class="right">
                      <div class="h" style="margin-left: 69px;margin-bottom: 17px;">
                        {{$t('home.queryShipment.number')}}
                        <span> {{$t('home.queryShipment.tips')}}</span>
                      </div>
                    <!-- 输入框 -->
                    <el-input v-model="expressNumber" class="expressInput" :placeholder="$t('home.queryShipment.placeholder')"></el-input>
                    </div>
                  </div>
                </div>
                <div class="bottom">
                  <optionsButton :title="$t('home.tab[1]')" :callback="trackNow"/>
                  <div class="help">{{$t('home.help')}}</div>
                </div>
              </div>
              <div class="tabItem" v-show="curTab===2">
                <div class="content">
                  <div class="progressBox">
                    <div class="left">
                      <div class="h">{{$t('home.localStorage.reserve.title')}}</div>
                      <p>{{$t('home.localStorage.reserve.description')}}</p>
                    </div>
                    <div class="right arrow">
                      <span class="el-icon-caret-right"></span>
                    </div>
                  </div>
                  <div class="progressBox">
                    <div class="left">
                      <div class="h">{{$t('home.localStorage.tidy.title')}}</div>
                      <p>{{$t('home.localStorage.tidy.description')}}</p>
                    </div>
                    <div class="right arrow">
                      <span class="el-icon-caret-right"></span>
                    </div>
                  </div>
                  <div class="progressBox">
                    <div class="left">
                      <div class="h">{{$t('home.localStorage.store.title')}}</div>
                      <p>{{$t('home.localStorage.store.description')}}</p>
                    </div>
                    <div class="right arrow">
                      <span class="el-icon-caret-right"></span>
                    </div>
                  </div>
                  <div class="progressBox">
                    <div class="left">
                      <div class="h">{{$t('home.localStorage.extract.title')}}</div>
                      <p>{{$t('home.localStorage.extract.description')}}</p>
                    </div>
                    <div class="right arrow">
                      <span class="el-icon-caret-right"></span>
                    </div>
                  </div>
                </div>
                <div class="bottom">
                  <optionsButton :title="$t('home.tab[0]')" :callback="quoteNow" />
                   <div class="help">{{$t('home.help')}}</div>
                </div>
              </div>
              <div class="tabItem" v-show="curTab===3">
                <div class="content">
                  <div class="progressBox">
                    <div class="left">
                      <div class="h">{{$t('home.JapanesePurchasingAgencyage.reserve.title')}}</div>
                      <p>{{$t('home.JapanesePurchasingAgencyage.reserve.description')}}</p>
                    </div>
                    <div class="right arrow">
                      <span class="el-icon-caret-right"></span>
                    </div>
                  </div>
                  <div class="progressBox">
                    <div class="left">
                      <div class="h">{{$t('home.JapanesePurchasingAgencyage.tidy.title')}}</div>
                      <p>{{$t('home.JapanesePurchasingAgencyage.tidy.description')}}</p>
                    </div>
                    <div class="right arrow">
                      <span class="el-icon-caret-right"></span>
                    </div>
                  </div>
                  <div class="progressBox">
                    <div class="left">
                      <div class="h">{{$t('home.JapanesePurchasingAgencyage.store.title')}}</div>
                      <p>{{$t('home.JapanesePurchasingAgencyage.store.description')}}</p>
                    </div>
                    <div class="right arrow">
                      <span class="el-icon-caret-right"></span>
                    </div>
                  </div>
                  <div class="progressBox">
                    <div class="left">
                      <div class="h">{{$t('home.JapanesePurchasingAgencyage.extract.title')}}</div>
                      <p>{{$t('home.JapanesePurchasingAgencyage.extract.description')}}</p>
                    </div>
                    <div class="right arrow">
                      <span class="el-icon-caret-right"></span>
                    </div>
                  </div>
                </div>
                <div class="bottom">
                  <optionsButton :title="$t('home.tab[3]')" :callback="JapaneseNow" />
                  <div class="help">{{$t('home.help')}}</div>
                </div>
              </div>
          </div>
          </div>
      </div>
    </section>
    <!-- 主体 -->
    <section class="main">
      <!-- 为什么选择good2go -->
      <div class="whyChoice pubw">
        <h2>{{$t('home.whyChoice.title')}}</h2>
        <ul>
          <li>
            <div class="img">
              <img src="@/assets/img/whyChoice/1.png" alt="">
            </div>
            <div class="h">{{$t('home.whyChoice.oneBlock.title')}}</div>
            <p>{{$t('home.whyChoice.oneBlock.text')}}</p>
          </li>
          <li>
            <div class="img">
              <img src="@/assets/img/whyChoice/2.png" alt="">
            </div>
            <div class="h">{{$t('home.whyChoice.twoBlock.title')}}</div>
            <p>{{$t('home.whyChoice.twoBlock.text')}}</p>
          </li>
          <li>
            <div class="img">
              <img src="@/assets/img/whyChoice/3.png" alt="">
            </div>
            <div class="h">{{$t('home.whyChoice.threeBlock.title')}}</div>
            <p>{{$t('home.whyChoice.threeBlock.text')}}</p>
          </li>
          <li>
            <div class="img">
              <img src="@/assets/img/whyChoice/4.png" alt="">
            </div>
            <div class="h">{{$t('home.whyChoice.fourBlock.title')}}</div>
            <p>{{$t('home.whyChoice.fourBlock.text')}}</p>
          </li>
        </ul>
      </div>

      <!-- 寄货流程 -->
      <div class="process pubw">
        <h2>寄貨流程</h2>
        <ul>
          <li>
            <div class="img">
              <img src="@/assets/img/process/1.png" alt="">
            </div>
            <div class="h">網上下單</div>
            <p>眾多物流伙伴 瞬間為你揀選
              合適路線</p>
          </li>
          <li>
            <div class="img">
              <img src="@/assets/img/process/2.png" alt="">
            </div>
            <div class="h">貨物報關</div>
            <p>眾多物流伙伴 瞬間為你揀選
              合適路線</p>
          </li>
          <li>
            <div class="img">
              <img src="@/assets/img/process/3.png" alt="">
            </div>
            <div class="h">預約取件</div>
            <p>眾多物流伙伴 瞬間為你揀選
              合適路線</p>
          </li>
          <li>
            <div class="img">
              <img src="@/assets/img/process/4.png" alt="">
            </div>
            <div class="h">支付完成</div>
            <p>眾多物流伙伴 瞬間為你揀選
              合適路線</p>
          </li>
        </ul>
      </div>

      <div class="swiperr pubw">
        <!-- 最新新闻 -->
        <div class="news">
          <h2>最新新聞</h2>
          <swiper ref="mySwiper" :options="swiperOptions">
            <swiper-slide v-for="item in newsList":key="item.id">
              <div class="box"  @click="showDetailsDiglog(item)">
                <div class="img">
                  <!-- <img :src="item.img" alt=""> -->
                  <img :src="`http://goods2go.com.hk/goods2go-user/img/${item.image}`" alt="">
                </div>
                <div class="h">{{_i18n.locale == 'en' ? item.titleEn : item.titleCn}}</div>
                <p>
                  <span>#最新新闻</span>
                </p>
             </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
        <!-- 常见问题 -->
        <div class="problem">
          <h2>常見問題</h2>
          <swiper ref="mySwiper" :options="swiperOptions">
            <swiper-slide v-for="item in proplemList":key="item.id">
              <div class="box" @click="showDetailsDiglog(item)">
                  <div class="img">
                    <!-- <img :src="item.img" alt=""> -->
                    <img :src="`http://goods2go.com.hk/goods2go-user/img/${item.image}`" alt="">
                  </div>
                  <div class="h">{{_i18n.locale == 'en' ? item.titleEn : item.titleCn}}</div>
                  <p>
                    <span>#常見問題</span>
                  </p>
              </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </div>

      <!-- 详情内容对话框 -->
      <el-dialog
        :title="_i18n.locale == 'en' ? detailsData.titleEn : detailsData.titleCn"
        :visible.sync="detailsDiglogShow"
        width="fit-content"
        :close-on-click-modal="false"
        >
        <div class="DigLogcontent">
          <div class="img">
            <!-- <img :src="`detailsData.img`" alt=""> -->
            <img :src="`http://goods2go.com.hk/goods2go-user/img/${detailsData.image}`" alt="">
          </div>
          <div class="text" v-html="_i18n.locale == 'en' ? detailsData.contentEn : detailsData.contentCn">
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="detailsDiglogShow = false">关 闭</el-button>
        </span>
      </el-dialog>
      <!-- 立即注册 -->
      <div class="registerNow">
        <div class="registerNow_main pubw">
          <div class="left">
            <div class="h">立即註冊Goods 2 Go</div>
            <p>免費申請帳戶，最快即日開通！</p>
          </div>
          <div class="right">
            <optionsButton  title="立即註冊" :callback="registerNow"/>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
  // 引入组件
  import optionsButton from '@/components/optionButton'
  import StartingEndPoint from "@/components/StartingEndPoint"
  export default {
    mame:'Header',
    components:{
      optionsButton,
      StartingEndPoint
    },
    data() {
      return {
        // 当前展示的头部标签
        curTab:0,
        // tab标签头部列表
        tabs_header:[
          {
            icon:'iconfont icon-jisuanqi',
            title: this.$t('home.tab[0]'),
            value:0
          },
          {
            icon:'iconfont icon-genzong',
            title:  this.$t('home.tab[1]'),
            value:1
          },
          {
            icon:'iconfont icon-fangzi',
            title:  this.$t('home.tab[2]'),
            value:2
          },
          {
            icon:'iconfont icon-swticonkuaidi',
            title:  this.$t('home.tab[3]'),
            value:3
          }
        ],
        // 发货地选项
        slipmentList:[
          {
            id:'0',
            country:'中国',
            icon:'el-icon-map-location'
          },
          {
            id:'1',
            country:'中国',
            icon:'el-icon-map-location'
          },
          {
            id:'2',
            country:'中国',
            icon:'el-icon-map-location'
          },
          {
            id:'3',
            country:'中国',
            icon:'el-icon-map-location'
          },
          {
            id:'4',
            country:'中国',
            icon:'el-icon-map-location'
          }
        ],
        // 当前选择的发货国家
        curSlipment:'香港',
        // 快递单号
        expressNumber:'',
        // 常见问题数据
        proplemList: [
          {
            id: '01',
            title: '寄藥同保健食品到海外',
            img: '../../assets/img/question/1.png',
            keyWord: [
              '#寄件教學','#食品'
            ],
            content: `A.運費以外,以下情况有可能淆生額外費用稅:
關稅是當地海按當地法例對郵件進行評稅、征稅的執法過程,當地海有可能授權快遞公司代為征收。無論你的寄件物品是甚麽,你的郵件都必須通過進口流程,並由收件地國家的海按法
律去決定是否需要繳税及需要付的税額由於所有關税細節均是由收件地海決定,税額的詳情要待郵件抵違收件國家後才能確認。
B.退運費用:
如因任何原因終止郵件運送或需要將郵件退回寄件人,寄件人需要支付郵件回程所淅生的所有費用
C.销毀費、罰款、手、行政費
如你的郵件包含任何禁運物品、未能提交快公司或當地海要求的設明文件,或寄件人虚報或未有如貴地申報寄件物品内容;當地海和快公司有權銷毀郵件,並向寄件 人徵收罰款、手費、行政費,金額完全由海和快遗公司決定。
請於寄件前榱查你發送的郵件内容是否在禁運物品清單( insert link)更多收詳情・請参htps:/umppointio/o
D.額外補充:運調整並追收或退回差額
侍你的郵件完成運送後快公司需時34星期不等與 jumppoint進行運貴調整・當我 們收到快公司的報告後,便會向信用卡追收或退回差額,並同時發出最終運費收據到 你的電郵此時整個交易過程才算正式完結。
如你的郵件於運送過程中淆生任何額外費用(例如由快公司收取的臨時繁忙時期或特殊 情況下的手貴、行政費漏報物品罰款等等) jumppoint會向你收取相費用並於最 終收據中列明
如你收到最终運貴收據後對收貴有不明白/異的地方·請向 jumppoint客服查均 jumppoint會為你向快週公司跟進。`
          },
          {
            id: '02',
            title: '快遞文件到海外',
            img: '../../assets/img/question/2.png',
            keyWord: [
              '#寄件教學','#食品'
            ]
          },
          {
            id: '03',
            title: '月餅海外快遞直送',
            img: '../../assets/img/question/3.png',
            keyWord: [
              '#寄件教學','#食品'
            ]
          }
        ],
        // 最新新闻问题数据
        newsList: [
        {
            id: '01',
            title: '寄藥同保健食品到海外',
            img: '../../assets/img/question/1.png',
            keyWord: [
              '#寄件教學','#食品'
            ],
            content: `A.運費以外,以下情况有可能淆生額外費用稅:
關稅是當地海按當地法例對郵件進行評稅、征稅的執法過程,當地海有可能授權快遞公司代為征收。無論你的寄件物品是甚麽,你的郵件都必須通過進口流程,並由收件地國家的海按法
律去決定是否需要繳税及需要付的税額由於所有關税細節均是由收件地海決定,税額的詳情要待郵件抵違收件國家後才能確認。
B.退運費用:
如因任何原因終止郵件運送或需要將郵件退回寄件人,寄件人需要支付郵件回程所淅生的所有費用
C.销毀費、罰款、手、行政費
如你的郵件包含任何禁運物品、未能提交快公司或當地海要求的設明文件,或寄件人虚報或未有如貴地申報寄件物品内容;當地海和快公司有權銷毀郵件,並向寄件 人徵收罰款、手費、行政費,金額完全由海和快遗公司決定。
請於寄件前榱查你發送的郵件内容是否在禁運物品清單( insert link)更多收詳情・請参htps:/umppointio/o
D.額外補充:運調整並追收或退回差額
侍你的郵件完成運送後快公司需時34星期不等與 jumppoint進行運貴調整・當我 們收到快公司的報告後,便會向信用卡追收或退回差額,並同時發出最終運費收據到 你的電郵此時整個交易過程才算正式完結。
如你的郵件於運送過程中淆生任何額外費用(例如由快公司收取的臨時繁忙時期或特殊 情況下的手貴、行政費漏報物品罰款等等) jumppoint會向你收取相費用並於最 終收據中列明
如你收到最终運貴收據後對收貴有不明白/異的地方·請向 jumppoint客服查均 jumppoint會為你向快週公司跟進。`
          },
          {
            id: '02',
            title: '快遞文件到海外',
            img: '../../assets/img/question/2.png',
            keyWord: [
              '#寄件教學','#食品'
            ]
          },
          {
            id: '03',
            title: '月餅海外快遞直送',
            img: '../../assets/img/question/3.png',
            keyWord: [
              '#寄件教學','#食品'
            ]
          }
        ],
        // 对话框内容数据
        detailsData: {
          title: '',
          img: '',
          content: '',
          keyWord: []
        },
        detailsDiglogShow: false,
        // 轮播图配置
        swiperOptions: {
          autoplay: 2000,
          speed: 300,
          slidesPerView: 2,
          pagination: {
            el: '.swiper-pagination',    //与slot="pagination"处 class 一致
            clickable: true,            //轮播按钮支持点击
          }
        },
        // 广播条数据
        broadcast: []
      }
    },
    mounted() {
    },
    methods: {
      // 监听Tab标签改变
      handleTabsChange(value){
        this.curTab = value
      },
      // 监听立即报价按钮点击
      quoteNow(){
        this.$router.push("mail")
      },
      // 监听日货代购按钮点击
      JapaneseNow(){
        this.$router.push("purchasing")
      },
      // 监听立即跟踪按钮点击
      trackNow(){
        console.log('track')
      },
      // 监听点击了解更多
      learnMore(){
        console.log('more')
      },
      // 监听点击立即注册
      registerNow(){
        this.$router.push('/register')
      },
      // 监听用户点击显示新闻详情或者常见问题详情
      showDetailsDiglog(item){
        console.log(item)
        this.detailsData = item
        this.detailsDiglogShow = true
      },
      // 获取最新新闻数据
      async getNewsData(){
        const res = await this.$http.get('/app/v2/list/news')
        this.newsList = res.data.data
        console.log(res, "最新新闻数据")
      },
      // 获取常见问题数据
      async getProplemData(){
        const res = await this.$http.get('/app/v2/list/problem')
        this.proplemList = res.data.data
        console.log(res, "常见问题数据")
      },
      // 获取广播条数据
      async getBroadCastData(){
        const res = await this.$http.get('/app/v2/list/placard')
        if(res.status == 200){
          this.broadcast = res.data.data
        }
        console.log(res, "广播条数据")
      }
    },
    created() {
      this.getNewsData()
      this.getProplemData()
      this.getBroadCastData()
    },
  }
</script>

<style lang="less" scoped>

  .banner{
    position: relative;
    height: 90%;
    .imgs{
      width: 100%;
      height: 90%;
      margin: 0 auto;
      img{
        width: 100%;
        height: 680px;
        object-fit: cover;
      }
    }
    .floating{
      display: flex;
      align-items: center;
      left: 50%;
      margin-left: -640px;
      justify-content: space-between;
      top: 31%;
      position: absolute;
      .left{
        .h{
          font-size: 30px;
          font-weight:550;
          color:#fff;
          width: 420px;
          margin-bottom:30px;
        }
        .bannerregisterNow{
          color: #474F8F;
          background-color: #fff;
        }
      }
      .right{
        width: 40px;
        height: 40px;
        color: #fff;
        text-align: center;
        background-color: #000;
        border-radius: 50%;
        font-size: 30px;
        line-height: 40px;
        span{
          margin-left: 5px;
        }
      }
      .right:hover{
          opacity: 0.5;
          cursor: pointer;
        }
    }
    .tabs{
      margin: 0 auto;
    }
  }
  .options{
    width: 100%;
    background-color: #f4f4f4;
    height: 343.44px;
    .options_main{
      height: 100%;
      margin: 0 auto;
      .tabs{
        position: relative;
        width: 100%;
        height: 100%;
        .tabs_header{
          position: relative;
          width: 398px;
          top: -60px;
          width: 491.25px;
          height: 127px;
          border-top-left-radius: 50px;
          border-top-right-radius: 50px;
          background-color: #f4f4f4;
          margin: 0 auto  ;
          display: flex;
          justify-content: space-around;
          align-items: center;
          span:first-child{
            font-size: 30px;
          }
          div{
            display: flex;
            flex-wrap: wrap;
            width: 72px;
            height: 58.7px;
            color: #c7c7c7;
            span{
              font-size: 18px;
              width: 100%;
              text-align: center;
            }
          }
          div:hover{
            cursor:pointer;
          }
        }
        .tabs_content{
          display: flex;
          justify-content: center;
          flex-wrap:wrap ;
          margin-top: -30px;
          .tips{
            width: 100%;
            margin-top: -20px;
            margin-bottom: 20px;

            .container{
              display: flex;
              animation: working 20s infinite linear ;
              .el-icon-warning{
                    color: #F7320F;
                }
              .prompt{
                  color:#F7320F;
              }
            }
          }
          .tabItem{
            width: 100%;
          }
          .content{
            display: flex;
            justify-content: space-between;
            .top{
              display: flex;
              justify-content: center;
              align-items: flex-start;
              width: 100%;
              height: 110px;
              .el-select{
                width: 575px;
                box-shadow: 0px 2px 6px #ccc;
                border-radius: 5px;
                border: none;
              }
                  input{
                    height: 56px !important;
                  }
              .h{
                margin-bottom: 20px;
                font-size: 17px;
                font-weight: 550;
                span{
                  font-weight: 500;
                  font-size:12px;
                  color:@colorMain;
                  margin-left:10px;
                }
              }
            }
          }
          .bottom{
            text-align: center;
            margin-top: 10px;
          }
          .left,.right{
            /* width: 460px;
            height: 56px; */
          }
          .expressInput{
            width: 575px;
            border-radius: 5px;
            border: none;
            margin-left: 69px;
          }
          .changeBtn{
            width: 35px;
            height: 35px;
            border-radius: 50%;
            background-color: @colorMain;
            text-align: center;
            line-height: 35px;
            color: #fff;
            font-size: 18px;
            margin:0  44px;
            margin-top: 33px;
          }
          .help{
            font-size: 13px;
            width: fit-content;
            white-space: nowrap;
            font-family: PingFang HK;
            color:#777986;
            border-bottom:2px solid #707070;
            padding-bottom:5px;
            margin: 0 auto;
            margin-top: 20px;
          }
          .help:hover{
            cursor: pointer;
          }
        }
      }
    }
  }
  // tab标签选中
  .tabs_header .tabsHeader_active{
    color: #474F8F !important;
  }
  .progressBox{
    display: flex;
    align-items: center;
    .left{
      width: 235px;
      height: 110px;
      margin-right:10px;
      border:2px solid @colorMain;
      border-radius:5px;
      padding:0 20px;
      text-align: center;
      &::-webkit-scrollbar {display:none}
      /* 文本超出处理 */
      overflow: auto;
      .h{
        font-size: 16px;
        color: @colorMain;
        font-weight: 550;
        text-align: center;
        margin-top: 8px;
        margin-bottom: 10px;
      }
      p{
        font-size: 14px;
        font-weight: 540;
        line-height: 20px;
      }
    }
    .right{
      span{
        font-size: 35px;
        color: @colorMain;
      }
    }
  }
  .progressBox:last-child .right span{
    opacity: 0;
  }
  .main{
    padding-top: 120px;
    .whyChoice{
      display: flex;
      flex-wrap: wrap;
      margin: 0 auto;
      justify-content: center;
      h2{
        width: 100%;
        text-align: center;
        font-size: 30px;
        margin-bottom: 60px;
        font-weight: 550;
      }
      ul{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        li{
          width: 220px;
          .img{
            width: 100%;
            height: 146px;
            img{
              width: 100%;
              height: 100%;
            }
          }
          .h{
            margin-top: 20px;
            margin-bottom: 12px;
            text-align: center;
            font-size: 23px;
            font-weight: 545;
          }
          p{
            font-size: 15px;
            font-family: PingFang HK;
            line-height: 25px;
            padding: 0 2px;
          }
        }
      }
    }
    .process{
      display: flex;
      flex-wrap: wrap;
      margin: 0 auto;
      justify-content: center;
      margin-top: 120px;
      h2{
        width: 100%;
        text-align: center;
        font-size: 30px;
        margin-bottom: 60px;
        font-weight: 550;
      }
      ul{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        li{
          width: 208px;
          .img{
            width: 54.36px;
            height: 70.93px;
            margin: 0 auto;
            img{
              width: 100%;
              height: 100%;
            }
          }
          .h{
            margin-top: 20px;
            margin-bottom: 12px;
            text-align: center;
            font-size: 23px;
            font-weight: 545;
          }
          p{
            font-size: 15px;
            font-family: PingFang HK;
            line-height: 25px;
            padding: 0 2px;
            text-align: center;
          }
        }
      }
    }
    .swiperr{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 120px;
      padding-bottom: 60px;
      .news{
        width: 50%;
      }
      .swiper-container{
        width: 100%;
      }
      .problem, .news{
        width: 45%;
        display: flex;
        flex-wrap: wrap;
        margin: 0 auto;
        justify-content: center;
        h2{
          width: 100%;
          text-align: center;
          font-size: 30px;
          margin-bottom: 30px;
          font-weight: 550;
        }
        .swiper-container{
          position: relative;
          width: 100%;
          overflow: hidden;
          padding-bottom: 20px;
          .box{
            .img{
              width: 270px;
              height: 180px;
              margin: 0 auto;
              img{
                width: 100%;
                height: 100%;
              }
            }
            .h{
              margin-top: 20px;
              margin-bottom: 12px;
              text-align: center;
              font-size: 23px;
              font-weight: 545;
            }
            p{
              font-size: 15px;
              font-family: PingFang HK;
              line-height: 25px;
              padding: 0 2px;
              text-align: center;
              span{
                margin: 0 5px;
                color:#777986;
              }
            }
          }
        }
      }
    }
    .registerNow{
      background-color: #f4f4f4;
      .registerNow_main{
        display: flex;
        justify-content: space-between;
        height: 252px;
        margin:0 auto;
        align-items: center;
        .left{
          .h{
            font-size: 30px;
            color:@colorMain;
            font-weight:550;
          }
          p{
            font-size: 13px;
            margin-top: 15px;
          }
        }
      }
    }
  }
      // 手机
  @media screen and (max-width: 765px){
      .pubw{
        margin-top: 50px !important;
        padding-bottom: 0px !important;
      }
      .main{
        padding-top: 10px;
      }
      .banner .floating{
        top: 25%;
        margin-left: 0px;
        left: 10px;
      }
      .banner .imgs img{
        object-fit: cover;
      }
      .banner .floating .left .h{
        width: 100%;
      }
      .banner .floating .right{
        display: none;
      }
      .options{
        height: auto;
        padding-bottom: 10px;
      }
      .options .options_main .tabs .tabs_content .left{
        width: 100%;
        text-align: center;
      }
          .options .options_main .tabs .tabs_content .right{
        width: 100%;
        text-align: center;
      }
      .options .options_main .tabs .tabs_content .content .top .el-select{
        width: 80%;
      }
      .options .options_main .tabs .tabs_content .changeBtn{
        margin: 10px  100px;
      }
      .options .options_main .tabs .tabs_content .content .top{
        flex-wrap: wrap;
      }
      .options .options_main .tabs .tabs_header{
        width: 100%;
      }
      .options .options_main .tabs .tabs_content .content .top .h{
        margin-left: 20px !important;
        margin: 15px 0;
        text-align: left;
      }
      .options .options_main .tabs .tabs_content .expressInput{
        margin-left: 0px;
        width: 80%;
      }
      .options .options_main .tabs .tabs_content .content{
        flex-wrap: wrap;
        justify-content: center;
      }
      .progressBox{
        flex-wrap: wrap;
      }
      .options .options_main .tabs .tabs_content .arrow{
        transform: rotate(90deg);
      }
      .options .options_main .tabs .tabs_content .left{
        width: 95%;
        margin: 0 auto;
      }
      .options .options_main .tabs .tabs_content .right{
        width: 95%;
        margin: 0 auto;
      }
      .main .whyChoice ul{
        justify-content: center;
        li{
          margin: 5px 0;
          width: 90%;
          .img{
            height: 50%;
          }
        }
      }
      .main .process ul li{
        width: 40%;
        margin: 5px 0;
      }
      .main .problem ul{
        justify-content: center;
        li{
          margin: 5px 0;
        }
      }
  }

  @keyframes working{
    0%{
      transform: translateX(100%);
    }
    100%{
      transform: translateX(-100%);
    }
  }
</style>

<style lang="less">
  .swiper-pagination{
    left: 50%;
    transform: translateX(-50%) !important;
  }
  .swiper-pagination-bullet{
    margin: 0 5px;
  }
  .swiper-pagination-bullet-active{
    background: #737cbe !important;
  }
  .DigLogcontent{
          .img{
            width: 100%;
            img{
              width: 100%;
            }
          }
          .text{
            text-indent: 20px;
            span{
              text-indent: 20px;
              line-height: 30px;
            }
          }
        }
</style>


<style lang="less">
    .cast{
      color: @colorMain;
      height: 20px;
      white-space:  nowrap;
      line-height: 20px;
      margin-right: 200px;
      img{
        height: 100%;
        max-width: 20px;
        margin-right: 5px;
      }
      *{
        display: flex;
        align-items: center;
        height: 100% !important;
        line-height: 20px;
      }
    }
</style>
